import { NodeTypeName } from "@app/types";
import BaseNodeModel from "../BaseNodeModel";
import { CreateAnchor, SelectAnchor } from "../../form_features";

export default class BannerNodeModel extends BaseNodeModel {
    /**
     * Banner Message node model
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);

        this.props.nodeTypeName = NodeTypeName.banner;
        this.props.colorClass = "yellow";
        this.props.iconClass = "radio";
        this.DEFAULT_COLOR_CLASS = "yellow";
        this.props.config.bannerAnchor = null;
        this.applyProps(props);
    }

    setConfig(key, value) {
        this.props.config[key] = value;
        super.setConfig(key, value);
    }

    getConfigViews() {

        return [
            ...this.getConfigViewNameField(),
            ...[
                <>
                    <hr />
                    <SelectAnchor context={this} />
                    <CreateAnchor context={this} />
                </>
            ]
        ]
    }

}